<template>
  <Dashboard />
</template>

<script>
import Dashboard from '@/components/Dashboard/Dashboard.vue';

export default {
  name: 'Home',
  components: {
    Dashboard,
  },
};
</script>
